import React from "react";
import AppFooter from "../footer-app/appFooter.js";
import MerchantFooter from "../footer-merchant/merchantFooter.js";
import "./style.css";
export default function Footer(props) {
    return (React.createElement("footer", { className: "gallery-footer" },
        props.merchantFooter ?
            React.createElement(MerchantFooter, { text: props.merchantFooter, context: props.context })
            : null,
        React.createElement(AppFooter, null)));
}
